<template>
  <div>
    <h3>我是 A 网页</h3>
    <h4>{{ random }}</h4>
  </div>
</template>

<script>
  export default {
    name: 'page-a'
  };
</script>

<style lang="scss" scoped>

</style>